'use client'

import ChooseShareButton from './ChooseShareButton'

/**
 * Persistent bottom bar, phones only (≤767px). Keeps the share action — the
 * whole point of the page — one tap away.
 */
export default function ChooseStickyBar() {
  return (
    <div className="hidden sm:flex fixed bottom-0 inset-x-0 z-50 items-stretch px-3 py-3 bg-white/95 backdrop-blur border-t border-black/10 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]">
      <ChooseShareButton variant="sticky" />
    </div>
  )
}
